<template>
  <v-container fluid class="pa-0">
    <!-- You can add placeholders for search/filters here if you want -->
    <v-skeleton-loader
      type="table-thead, table-tbody, table-tfoot"
      class="mx-auto"
    ></v-skeleton-loader>
  </v-container>
</template>

<script setup>
// VSkeletonLoader is auto-imported by Vuetify's plugin — no explicit import needed.
</script>